import { TextStyle } from "./common.js";
const baseParagraphData = {};
const ParagraphData = {
  fromJSON(object) {
    const message = { ...baseParagraphData };
    message.textStyle = object.textStyle !== void 0 && object.textStyle !== null ? TextStyle.fromJSON(object.textStyle) : void 0;
    message.indentation = object.indentation !== void 0 && object.indentation !== null ? Number(object.indentation) : void 0;
    message.level = object.level !== void 0 && object.level !== null ? Number(object.level) : void 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.textStyle !== void 0 && (obj.textStyle = message.textStyle ? TextStyle.toJSON(message.textStyle) : void 0);
    message.indentation !== void 0 && (obj.indentation = message.indentation);
    message.level !== void 0 && (obj.level = message.level);
    return obj;
  }
};
export {
  ParagraphData
};
//# sourceMappingURL=node_paragraph.js.map
